module.exports = __webpack_public_path__ + "static/media/gallery02.86585658.png";